// @ts-nocheck

import React from 'react';

import { ModalContentSpacing, ModalFormat } from '../../constants/ui/modal';
import theme from '../../styled-components/dark';
import type { UserAccountPage } from '../../types/user-account';
import Modal from '../Modal';
import UserAccountContainer from '../UserAccount/UserAccountContainer';

type UserAccountModalViewProps = {
  className?: string;
  subpath?: UserAccountPage | null;
};

const UserAccountModalView = ({ className, subpath }: UserAccountModalViewProps) => {
  return (
    <Modal
      contentSpacing={ModalContentSpacing.NONE}
      format={ModalFormat.FULLSCREEN}
      zIndex={theme.ZIndices.userAccountModal}
    >
      <UserAccountContainer className={className} subpath={subpath} />
    </Modal>
  );
};

export default UserAccountModalView;
